import { render, staticRenderFns } from "./ConfirmChangeEndpointNameModal.vue?vue&type=template&id=a4133de0&scoped=true&"
import script from "./ConfirmChangeEndpointNameModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmChangeEndpointNameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4133de0",
  null
  
)

export default component.exports